/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$( document ).ready(function() {
    $('.annoucement-owl-carousel').owlCarousel({
        items: 1,
        nav: true,
        dots:false,
      	autoplay:true,
 	   autoplayTimeout:4000,
        loop:true,
          margin:10,
          responsive:{
              0:{
                  items:1,
                  dots:false
              },
              600:{
                  items:1,
                  dots:false
              },
              1000:{
                  items:1,
                  dots:false
              }
          },
        navText: [
          '<div class="arrow-container"><i class="fa fa-angle-left"></i></div>',
          '<div class="arrow-container"><i class="fa fa-angle-right"></i></div>',
        ]
      });
});
          
  $(document).ready(function(){
  $("#Open--model").click(function(){
    $(".Product__Wrapper").addClass("blurred");
          
  });
          
          $("#Modal__Close").click(function(){
    $(".Product__Wrapper").removeClass("blurred");
          
  });
         
});